(function () {
  var racine = document.getElementById("conseil");
  if (!racine) return;
  function partie(nom) {
    return racine.querySelector('[data-chat-part="' + nom + '"]');
  }
  var bulle = partie("toggle"),
    panneau = partie("panel"),
    fil = partie("thread"),
    form = partie("form"),
    champ = partie("input"),
    envoyer = partie("send"),
    idees = partie("suggestions"),
    fermer = partie("close");
  var fichier = partie("file"),
    apercu = partie("preview"),
    apercuImg = apercu.querySelector("img"),
    retirer = partie("preview-remove");
  var CLE = "mds-conseil",
    messages = [],
    occupe = false,
    photo = null;
  var TEXTE_PHOTO = "Voici ma pièce, que me conseillez-vous ?",
    MARQUE_PHOTO = "(photo de ma pièce) ";
  var CLE_GARDE = "0x4AAAAAAFjsdWXpxUb9ipjJ",
    garde = null,
    gardeId = null,
    gardeSert = false,
    attenteJeton = null,
    session = "";
  try {
    session = sessionStorage.getItem("mds-conseil-session") || "";
  } catch (e) {}
  if (!/^[a-z0-9]{8,40}$/.test(session)) {
    session = (Date.now().toString(36) + Math.random().toString(36).slice(2, 12)).replace(/[^a-z0-9]/g, "");
    try {
      sessionStorage.setItem("mds-conseil-session", session);
    } catch (e) {}
  }

  function chargerGarde() {
    if (garde) return garde;
    garde = new Promise(function (ok) {
      window.mdsGardePret = function () {
        try {
          var boite = document.createElement("div");
          boite.className = "visually-hidden";
          racine.appendChild(boite);
          gardeId = window.turnstile.render(boite, {
            sitekey: CLE_GARDE,
            execution: "execute",
            retry: "never",
            "refresh-expired": "never",
            callback: function (t) {
              if (attenteJeton) attenteJeton(t);
            },
            "error-callback": function () {
              if (attenteJeton) attenteJeton("");
              return true;
            },
          });
          ok(true);
        } catch (e) {
          ok(false);
        }
      };
      var s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=mdsGardePret";
      s.async = true;
      s.onerror = function () {
        ok(false);
      };
      document.head.appendChild(s);
      setTimeout(function () {
        ok(false);
      }, 8000);
    });
    return garde;
  }

  function prendreJeton() {
    return chargerGarde().then(function (pret) {
      if (gardeId == null) return "";
      return new Promise(function (ok) {
        var fini = false;
        attenteJeton = function (t) {
          if (fini) return;
          fini = true;
          attenteJeton = null;
          ok(t || "");
        };
        setTimeout(function () {
          if (attenteJeton) attenteJeton("");
        }, 6000);
        try {
          if (gardeSert) window.turnstile.reset(gardeId);
          gardeSert = true;
          window.turnstile.execute(gardeId);
        } catch (e) {
          attenteJeton("");
        }
      });
    });
  }

  function preparerPhoto(f) {
    return new Promise(function (ok, ko) {
      if (!f || !/^image\//.test(f.type)) return ko();
      var img = new Image(),
        url = URL.createObjectURL(f);
      img.onload = function () {
        var cote = 1024,
          r = Math.min(1, cote / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement("canvas");
        c.width = Math.round(img.naturalWidth * r);
        c.height = Math.round(img.naturalHeight * r);
        c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        var donnees = c.toDataURL("image/jpeg", 0.8);
        ok({ type: "image/jpeg", data: donnees.split(",")[1], url: donnees });
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        ko();
      };
      img.src = url;
    });
  }

  function oublierPhoto() {
    photo = null;
    fichier.value = "";
    apercu.hidden = true;
    apercuImg.removeAttribute("src");
  }

  try {
    messages = JSON.parse(sessionStorage.getItem(CLE) || "[]");
  } catch (e) {
    messages = [];
  }
  if (!Array.isArray(messages)) messages = [];

  function garder() {
    try {
      sessionStorage.setItem(CLE, JSON.stringify(messages.slice(-16)));
    } catch (e) {}
  }

  function echapper(t) {
    return t
      .replace(/(\d) x (?=\d)/g, "$1 x ")
      .replace(/(\d) (?=(cm|m|mm|kg|€|%|mètres|jours|semaines)(?![a-zà-ÿ]))/g, "$1 ")
      .replace(/(\d) (?=\d{3}(?!\d))/g, "$1 ")
      .replace(/ ([?!:;»])/g, " $1")
      .replace(/« /g, "« ")
      .replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
  }

  function enrichir(t) {
    return echapper(t)
      .replace(/https:\/\/(www\.)?magiedusalon\.fr\/[^\s<),;]*[^\s<),;.:]/g, function (u) {
        return '<a href="' + u + '">' + u.replace(/^https:\/\/(www\.)?/, "") + "</a>";
      })
      .replace(/bonjour@magiedusalon\.fr/g, '<a href="mailto:bonjour@magiedusalon.fr">bonjour@magiedusalon.fr</a>');
  }

  function bulleMessage(role, texte, image) {
    var p = document.createElement("p");
    p.className = "chat-widget__message chat-widget__message--" + (role === "user" ? "user" : "bot");
    if (role === "user" && texte.indexOf(MARQUE_PHOTO) === 0) texte = texte.slice(MARQUE_PHOTO.length);
    p.innerHTML = role === "user" ? echapper(texte) : enrichir(texte);
    if (image) {
      var im = document.createElement("img");
      im.src = image;
      im.alt = "Votre photo";
      p.insertBefore(im, p.firstChild);
    }
    fil.appendChild(p);
    fil.scrollTop = fil.scrollHeight;
    return p;
  }

  function afficherTout() {
    fil.querySelectorAll(".chat-widget__message:not(.chat-widget__message--welcome)").forEach(function (n) {
      n.remove();
    });
    messages.forEach(function (m) {
      bulleMessage(m.role, m.content);
    });
    idees.hidden = messages.length > 0;
  }

  var appareil = partie("photo"),
    astuce = null;

  function appeler() {
    appareil.classList.remove("is-highlighted");
    void appareil.offsetWidth;
    appareil.classList.add("is-highlighted");
    if (!astuce) {
      astuce = document.createElement("p");
      astuce.className = "chat-widget__message chat-widget__message--bot chat-widget__message--tip";
      astuce.textContent =
        "Touchez l'appareil photo en bas pour ajouter une photo de votre pièce. Je vous conseille la taille, la teinte et le modèle.";
    }
    idees.hidden = true;
    fil.appendChild(astuce);
    fil.scrollTop = fil.scrollHeight;
  }

  function calmer() {
    appareil.classList.remove("is-highlighted");
  }

  function ouvrir(avecPhoto) {
    racine.classList.add("is-open");
    document.documentElement.classList.add("has-open-chat");
    panneau.setAttribute("aria-hidden", "false");
    bulle.setAttribute("aria-expanded", "true");
    afficherTout();
    chargerGarde();
    if (avecPhoto) appeler();
    else if (!feuille.matches)
      setTimeout(function () {
        champ.focus();
      }, 60);
    suivreClavier();
  }

  function refermer() {
    racine.classList.remove("is-open");
    document.documentElement.classList.remove("has-open-chat");
    calmer();
    panneau.setAttribute("aria-hidden", "true");
    bulle.setAttribute("aria-expanded", "false");
    bulle.focus();
  }

  function demander(question) {
    question = (question || "").trim().slice(0, 600);
    if (!question && photo) question = TEXTE_PHOTO;
    if (!question || occupe) return;
    occupe = true;
    envoyer.disabled = true;
    idees.hidden = true;
    var jointe = photo;
    messages.push({ role: "user", content: (jointe ? MARQUE_PHOTO : "") + question });
    bulleMessage("user", question, jointe && jointe.url);
    champ.value = "";
    ajuster();
    oublierPhoto();
    var corps = { messages: messages.slice(-15), page: location.pathname.slice(0, 200), session: session };
    if (jointe) corps.photo = { type: jointe.type, data: jointe.data };
    var attente = bulleMessage("assistant", "");
    attente.classList.add("chat-widget__message--typing");
    attente.innerHTML = "<span></span><span></span><span></span>";
    prendreJeton()
      .then(function (j) {
        corps.jeton = j;
        return fetch("/api/conseil", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(corps),
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        return d.reponse || "Je n'arrive pas à répondre pour le moment. Écrivez-nous à bonjour@magiedusalon.fr.";
      })
      .catch(function () {
        return "La connexion a coupé. Écrivez-nous à bonjour@magiedusalon.fr.";
      })
      .then(function (texte) {
        attente.remove();
        messages.push({ role: "assistant", content: texte });
        if (messages.length > 16) messages = messages.slice(-16);
        bulleMessage("assistant", texte);
        garder();
        occupe = false;
        envoyer.disabled = false;
        champ.focus();
      });
  }

  function ajuster() {
    champ.style.height = "auto";
    champ.style.height = Math.min(champ.scrollHeight, 120) + "px";
    champ.style.overflowY = champ.scrollHeight > 120 ? "auto" : "hidden";
  }

  var feuille = window.matchMedia("(max-width: 640px)"),
    vv = window.visualViewport;
  function suivreClavier() {
    if (!vv) return;
    var bas = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    panneau.style.setProperty("--chat-keyboard-offset", bas + "px");
    panneau.style.setProperty("--chat-viewport-height", vv.height + "px");
  }
  if (vv) {
    vv.addEventListener("resize", suivreClavier);
    vv.addEventListener("scroll", suivreClavier);
  }
  var fond = partie("backdrop");
  if (fond) fond.addEventListener("click", refermer);
  var tire = null;
  racine.querySelectorAll(".chat-widget__grip").forEach(function (z) {
    z.addEventListener("pointerdown", function (e) {
      if (!feuille.matches || e.target.closest("button")) return;
      tire = { y: e.clientY, t: Date.now(), d: 0, id: e.pointerId };
      racine.classList.add("is-dragging");
      z.setPointerCapture(e.pointerId);
    });
    z.addEventListener("pointermove", function (e) {
      if (!tire || e.pointerId !== tire.id) return;
      tire.d = Math.max(0, e.clientY - tire.y);
      panneau.style.setProperty("--chat-drag-offset", tire.d + "px");
    });
    function lacher(e) {
      if (!tire || e.pointerId !== tire.id) return;
      var vite = tire.d / Math.max(1, Date.now() - tire.t) > 0.6,
        loin = tire.d > 90;
      tire = null;
      racine.classList.remove("is-dragging");
      panneau.style.setProperty("--chat-drag-offset", "0px");
      if (vite || loin) refermer();
    }
    z.addEventListener("pointerup", lacher);
    z.addEventListener("pointercancel", lacher);
  });

  bulle.addEventListener("click", function () {
    racine.classList.contains("is-open") ? refermer() : ouvrir(false);
  });
  fermer.addEventListener("click", refermer);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && racine.classList.contains("is-open")) refermer();
  });
  document.addEventListener(
    "click",
    function (e) {
      var a = e.target.closest && e.target.closest("[data-conseil]");
      if (!a) return;
      e.preventDefault();
      ouvrir(a.hasAttribute("data-conseil-photo"));
    },
    true,
  );
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    demander(champ.value);
  });
  champ.addEventListener("input", ajuster);
  champ.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      demander(champ.value);
    }
  });
  idees.addEventListener("click", function (e) {
    var b = e.target.closest("button");
    if (b) demander(b.textContent);
  });
  fichier.addEventListener("click", calmer);
  fichier.addEventListener("change", function () {
    preparerPhoto(fichier.files[0]).then(
      function (p) {
        photo = p;
        apercuImg.src = p.url;
        apercu.hidden = false;
        champ.focus();
      },
      function () {
        oublierPhoto();
      },
    );
  });
  retirer.addEventListener("click", function () {
    oublierPhoto();
    champ.focus();
  });
  if (location.hash === "#conseil") ouvrir(false);
})();
